export const FETCH_RECORDING_BY_PROFILE_REQUEST = 'FETCH_RECORDING_BY_PROFILE_REQUEST';
export const FETCH_RECORDING_BY_PROFILE_SUCCESS = 'FETCH_RECORDING_BY_PROFILE_SUCCESS';
export const FETCH_RECORDING_BY_PROFILE_FAILURE = 'FETCH_RECORDING_BY_PROFILE_FAILURE';

export const FETCH_RECORDING_GET_EVENT_REQUEST = 'FETCH_RECORDING_GET_EVENT_REQUEST';
export const FETCH_RECORDING_GET_EVENT_SUCCESS = 'FETCH_RECORDING_GET_EVENT_SUCCESS';
export const FETCH_RECORDING_GET_EVENT_FAILURE = 'FETCH_RECORDING_GET_EVENT_FAILURE';
